export default __webpack_public_path__ + "static/media/FelizNavidad.27f4c7e2.mp3";